import { TFunction } from 'i18next';
import { DeviceType } from 'shared/models/device-type';

import Device from 'features/device/domain/models/device';
import LinkableDevice from 'features/device/linkable-device/domain/models/linkable-device';

export function deviceDisplayType(t: TFunction, device: Device | LinkableDevice | undefined | null): string {
  if (device) {
    return device.displayType ?? t(`${device.type}`);
  }

  return t(`${DeviceType.Universal}`);
}
